// extracted by mini-css-extract-plugin
export var actionButton = "_i7-t";
export var buttonContainer = "_i7-0";
export var buttonContainer2 = "_i7-1";
export var buttonSection = "_i7-2";
export var details = "_i7-3";
export var dropdownItem = "_i7-5";
export var dropdownItemsContainer = "_i7-4";
export var fileInput = "_i7-r";
export var headerButton = "_i7-6";
export var icon = "_i7-7";
export var input = "_i7-8";
export var macroListItem = "_i7-9";
export var mainContent = "_i7-a";
export var microText = "_i7-b";
export var modal = "_i7-w";
export var optionsButton = "_i7-c";
export var paperclip = "_i7-s";
export var pillContent = "_i7-d";
export var preview = "_i7-e";
export var preview2 = "_i7-f";
export var quillEditor = "_i7-q";
export var selectedMacro = "_i7-g";
export var sidebar = "_i7-h";
export var sidebarHeader = "_i7-j";
export var sidebarList = "_i7-i";
export var sidebarListItem = "_i7-k";
export var sidebarSearch = "_i7-l";
export var snoozeDurationWrapper = "_i7-v";
export var statusPillContainer = "_i7-m";
export var tagsContainer = "_i7-n";
export var unselectedMacro = "_i7-o";
export var variable = "_i7-u";
export var wrapper = "_i7-p";